import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { dxDiagnosisResultApiClient } from '@src/api/company/dxDiagnosis/dxDiagnosisResultApiClient';
import { useAsyncHandler } from '@src/hooks/useAsyncHandler';
import Button from '@src/ui/elements/button/Button';
import { useLocation, useNavigate } from 'react-router-dom';

function DxDiagnosisExplanation() {
  const navigate = useNavigate();
  const location = useLocation();
  const diagnosisResultId = new URLSearchParams(location.search).get('id');

  const { loading: isLoadingNext, execute: handleNext } = useAsyncHandler(async () => {
    if (diagnosisResultId) {
      navigate(`/dx-diagnosis/${diagnosisResultId}/questions/1`);
      return;
    }

    const response = await dxDiagnosisResultApiClient.create();
    handleApiResponse(response, (data) => {
      navigate(`/dx-diagnosis/${data.dx_diagnosis_result_id}/questions/1`);
    });
  });

  const handleBack = () => {
    navigate('/dx-diagnosis');
  };
  return (
    <main className='min-h-screen bg-[#F9F9F9] px-6 py-20 lg:pt-24'>
      <div className='mx-auto max-w-[900px] bg-white px-[115px] py-[30px] lg:px-10'>
        <h1 className='text-center text-[30px] font-semibold text-primary-500'>DX診断について</h1>
        <p className='mt-8 leading-loose'>
          企業にとって、デジタル変革（DX）は競争力を高めるための重要なステップです。
          <br />
          しかし、多くの企業がどこから始めればよいか、どの程度進んでいるのかを把握するのが難しいとされています。そこで、この診断は、企業のデジタル成熟度を評価し、具体的な改善ポイントを明確化するために設計されました。
        </p>
        <p className='mt-8 leading-loose'>
          この診断では、DXに関する6つの主要なステージに沿った設問に回答することで、現在のDXの状況を総合的に理解することができます。結果は視覚的に分かりやすく表示され、企業が次に取るべきアクションを理解しやすくなります。
        </p>
        <p className='mt-8 leading-loose'>
          特に、企業が抱える固有の課題やリソースの制約に配慮し、最適なDX推進プランを提案することを目指しています。この診断を通じて、自社の強みと課題を理解し、持続的な成長に向けた第一歩を踏み出しましょう。
        </p>

        <div className='mt-8 border border-gray-200 bg-gray-10 p-6'>
          <h2 className='font-medium'>DX診断結果および属性情報の活用について</h2>
          <p className='mt-4 text-sm leading-[1.8em]'>
            本サービスでは、DX診断における結果やご回答いただいた企業の業種、売上規模などの属性情報を収集し、匿名化した統計データとして活用させていただきます。これらのデータは、より質の高いサービス提供や統計分析を通じたDX推進の支援に役立てることを目的としています。なお、個人情報は一切含まれませんので、ご安心ください。
          </p>
        </div>

        <div className='mt-8 flex justify-center gap-[30px]'>
          <div className='w-[172px]'>
            <Button
              size='m'
              variant='primary'
              outline
              fullRounded
              fullWidth
              onClick={handleBack}
            >
              前に戻る
            </Button>
          </div>
          <div className='w-[172px]'>
            <Button
              size='m'
              variant='primary'
              fullRounded
              fullWidth
              onClick={handleNext}
              loading={isLoadingNext}
            >
              回答に進む
            </Button>
          </div>
        </div>
      </div>
    </main>
  );
}

export default DxDiagnosisExplanation;
